import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as GasrecTypes,
  Creators as RecRetiredActions,
} from '../ducks/RecRetired';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';
import { isUnexpectedError, businessMessage, GENERIC_ERROR } from '../../util/apiError';
import { reportApiError } from '../../util/glitchtip';

function* getGasrecs({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/transactions', {
      params: payload,
    });
    if (status === 200) {
      yield put(RecRetiredActions.getGasrecsSuccess(data));
    }
    else{
      Sentry.captureMessage('getGasrecs failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      RecRetiredActions.getGasrecsError('Error listing Gasrecs')
    );
  }
}


function* getGasrecById({ payload }) {
  try {
    const { status, data } = yield call(api.get, `/transactions/${payload.id}`);
    if (status === 200) {
      yield put(RecRetiredActions.getGasrecByIdSuccess(data));
    }
    else{
      Sentry.captureMessage('getGasrecById failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(
      RecRetiredActions.getGasrecByIdError('gasrec not found')
      );
    }
  }

  function* postGasrec({ payload }) {
    try {
      const { status } = yield call(api.post, '/transactions/transfer-client', payload, {
        skipSentry: true,
        headers: {
          ...(payload instanceof FormData
            ? { 'Content-Type': 'multipart/form-data' }
            : {}),
        },
      });
      if (status === 200) {
        yield put(RecRetiredActions.postGasrecSuccess());
      }
      else{
        Sentry.captureMessage('postGasrec failed: status not 200', {
          level: 'error',
          extra: { payload, status },
        });
      }
    } catch (error) {
      const unexpected = isUnexpectedError(error);
      const reference = yield call(reportApiError, error, {
        flow: 'aposentadoria',
        endpoint: '/transactions/transfer-client',
        payload,
        unexpected,
      });
      yield put(
        RecRetiredActions.postGasrecError({
          message: unexpected ? GENERIC_ERROR : businessMessage(error) || GENERIC_ERROR,
          reference,
          unexpected,
        })
      );
    }
  }

function* getGasrecsWatcher() {
  yield takeLatest(GasrecTypes.GET_GASRECS, getGasrecs);
}

function* postGasrecWatcher() {
  yield takeLatest(GasrecTypes.POST_GASREC, postGasrec);
}

function* getGasrecByIdWatcher() {
  yield takeLatest(GasrecTypes.GET_GASREC_BY_ID, getGasrecById);
}

export default function* rootSaga() {
  yield all([
    fork(getGasrecsWatcher),
    fork(postGasrecWatcher),
    fork(getGasrecByIdWatcher),
  ]);
}
